/** One-shot symbol handoff between Edge surfaces (Flow watch -> Path Cloud / Structure Lab / Flow Tape). */
export const EDGE_SYMBOL_KEY = "mmec_edge_symbol";

export function setEdgeSymbol(symbol: string): void {
    try {
        sessionStorage.setItem(EDGE_SYMBOL_KEY, String(symbol || "").trim().toUpperCase());
    } catch {
        /* private mode */
    }
}

/** Read the handed-off symbol once and clear it. `prefer` (e.g. a URL param) wins but the key is still cleared. */
export function takeEdgeSymbol(prefer?: string | null): string | null {
    let v: string | null = null;
    try {
        v = sessionStorage.getItem(EDGE_SYMBOL_KEY);
        sessionStorage.removeItem(EDGE_SYMBOL_KEY);
    } catch {
        /* private mode */
    }
    if (prefer) return prefer;
    return v && /^[A-Za-z.^]{1,10}$/.test(v) ? v.toUpperCase() : null;
}

export function goToTab(tab: string): void {
    window.dispatchEvent(new CustomEvent("navigate-to-tab", { detail: { tab } }));
}
